// Step name constants
export const STEP_NAME_START = "START";
export const STEP_NAME_APPLICATION_DETAILS = "APPLICATION_DETAILS";
export const STEP_NAME_ABOUT_YOUR_HELPER = "ABOUT_YOUR_HELPER";
export const STEP_NAME_HELPER_BASIC = "HELPER_BASIC";
export const STEP_NAME_HELPER_EMPLOYMENT = "HELPER_EMPLOYMENT";
export const STEP_NAME_HELPER_ADDITIONAL = "HELPER_ADDITIONAL";
export const STEP_NAME_EMPLOYER_BASIC = "EMPLOYER_BASIC";
export const STEP_NAME_CONTRACT_DETAILS = "CONTRACT_DETAILS";
export const STEP_NAME_PLAN_SELECTION = "PLAN_SELECTION";
export const STEP_NAME_COVERAGE_OPTIONS = "COVERAGE_OPTIONS";
export const STEP_NAME_DOCUMENTS = "DOCUMENTS";
export const STEP_NAME_SUMMARY = "SUMMARY";

export const headerStepperData = [
    {
        key: STEP_NAME_START,
        title_en: "Start",
        title_ar: "ابدأ",
    },
    {
        key: STEP_NAME_APPLICATION_DETAILS,
        title_en: "Details",
        title_ar: "التفاصيل",
    },
    {
        key: STEP_NAME_ABOUT_YOUR_HELPER,
        title_en: "Helper",
        title_ar: "العامل المنزلي",
    },
    {
        key: STEP_NAME_DOCUMENTS,
        title_en: "Documents",
        title_ar: "الوثائق",
    },
    {
        key: STEP_NAME_SUMMARY,
        title_en: "Pay",
        title_ar: "المراجعة والدفع",
    },
];